import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'
import {
    getDataChartTaskSystem,
    getDataChartTaskUser,
    getDatachartEventObject,
    getDatachartObjectEvent,
    getDataCollectedByTier,
    getDataChartUserTasks,
    getDatachartOrgTask,
    getDataUsercollected,
    
} from '../../services/apis/Statitical'
import { getListEventAboutTime } from '../../services/apis/EventAPIServices'
import {
    getListTaskOfUser,
    getListTask,
    getTodoTask,
    getTodoTaskAdmin
} from '../../services/apis/TaskApiServices'

// api

function* saga_getListEventDashboard(action) {
    try {
        const { begin_time, end_time, mode } = action.payload
        const request = yield call(getListEventAboutTime, begin_time, end_time)
        console.log('mode', mode)
        console.log('data event dashboard', request)
        if (request.error.code === 200) {
            yield put(
                actions.action.getListEventDashboardDone(request.data, mode)
            )
        } else {
            yield put(actions.action.getListEventDashboardDone([], mode))
        }
    } catch (ex) {
        console.log('load data event dashboard : ', ex.message)
    }
}

function* saga_chartUserCollected(action) {
    try {
        const { typeSelect, month, year, begin_time, end_time } = action.payload
        const request = yield call(
            getDataUsercollected,
            typeSelect,
            month,
            year,
            begin_time,
            end_time
        )
        if (request.error.code === 200) {
            yield put(
                actions.action.loadDataChartUserCollectedDone(request.data)
            )
        } else {
            yield put(actions.action.loadDataChartUserCollectedDone([]))
        }
    } catch (ex) {
        console.log('load data chart user collected: ', ex.message)
    }
}

function* saga_chartOrgTask(action) {
    try {
        const { typeSelect, month, year, begin_time, end_time } = action.payload
        const request = yield call(
            getDatachartOrgTask,
            typeSelect,
            month,
            year,
            begin_time,
            end_time
        )
        if (request.error.code === 200) {
            yield put(actions.action.loadDataChartOrgTaskDone(request.data))
        } else {
            yield put(actions.action.loadDataChartOrgTaskDone([]))
        }
    } catch (ex) {
        console.log('load data chart User task : ', ex.message)
    }
}

function* saga_chartUserTask(action) {
    try {
        const { typeSelect, begin_time, end_time, month, year } = action.payload
        const request = yield call(
            getDataChartUserTasks,
            typeSelect,
            begin_time,
            end_time,
            month,
            year
        )
        if (request.error.code === 200) {
            yield put(actions.action.loadDataChartUserTaskDone(request.data))
        } else {
            yield put(actions.action.loadDataChartUserTaskDone([]))
        }
    } catch (ex) {
        console.log('load data chart User task : ', ex.message)
    }
}

function* saga_getDataCollectedByTier(action) {
    try {
        const { typeSelect, month, year } = action.payload
        const request = yield call(
            getDataCollectedByTier,
            typeSelect,
            month,
            year
        )
        if (request.error.code === 200) {
            yield put(actions.action.loadDataCollectedByTierDone(request.data))
        } else {
            yield put(actions.action.loadDataCollectedByTierDone([]))
        }
    } catch (ex) {
        console.log('load data chart  collected by tier : ', ex.message)
    }
}

function* saga_ChartObjectEvent(action) {
    try {
        const {
            typeSelect,
            month,
            year,
            begin_time,
            end_time,
            page_number,
            page_size,
            isRefresh,
        } = action.payload

        const request = yield call(
            getDatachartObjectEvent,
            typeSelect,
            month,
            year,
            begin_time,
            end_time,
            page_number,
            page_size
        )
        console.log('request data', request)
        if (request.error.code === 200) {
            yield put(
                actions.action.loadDataChartObjectEventDone(
                    request.data,
                    {
                        page_number: page_number,
                        total: request.total,
                    },
                    isRefresh
                )
            )
        } else {
            console.log('nodata')
            yield put(
                actions.action.loadDataChartObjectEventDone(
                    [],
                    {
                        page_number: 1,
                        total: 0,
                    },
                    isRefresh
                )
            )
        }
    } catch (ex) {
        console.log('load data chart  object event : ', ex.message)
    }
}
function* saga_ChartEventObject(action) {
    try {
        const {
            typeSelect,
            month,
            year,
            begin_time,
            end_time,
            page_number,
            page_size,
            isRefresh,
        } = action.payload
        const request = yield call(
            getDatachartEventObject,
            typeSelect,
            month,
            year,
            begin_time,
            end_time,
            page_number,
            page_size
        )

        if (request.error.code === 200) {
            yield put(
                actions.action.loadDataChartEventObjectDone(
                    request.data,
                    {
                        page_number: page_number,
                        total: request.total,
                    },
                    isRefresh
                )
            )
        } else {
            yield put(
                actions.action.loadDataChartEventObjectDone(
                    [],
                    {
                        page_number: 1,
                        total: 0,
                    },
                    isRefresh
                )
            )
        }
    } catch (ex) {
        console.log('load data chart event object : ', ex.message)
    }
}

function* saga_loadDataChartUserSystem(action) {
    try {
        const { typeSelect, month, year } = action.payload
        const request = yield call(
            getDataChartTaskUser,
            typeSelect,
            month,
            year
        )
        if (request.error.code === 200) {
            yield put(actions.action.loadDataChartUserSystemDone(request.data))
        } else {
            yield put(actions.action.loadDataChartUserSystemDone([]))
        }
    } catch (ex) {
        console.log('load data chart : ', ex.message)
    }
}
function* saga_loadDataChartTaskSystem(action) {
    try {
        const { typeSelect, month, year } = action.payload
        const request = yield call(
            getDataChartTaskSystem,
            typeSelect,
            month,
            year
        )
        if (request.error.code === 200) {
            yield put(actions.action.loadDataChartSystemTaskDone(request.data))
        } else {
            yield put(actions.action.loadDataChartSystemTaskDone([]))
        }
    } catch (ex) {
        console.log('load data chart : ', ex.message)
    }
}
function* saga_getListTaskAdmin(action) {
    try {
        const { page_number, page_size, deleted, isRefresh } = action.payload
        const request = yield call(getTodoTaskAdmin, page_number, page_size, deleted)
        console.log('data request', request)
        if (request.error.code === 200) {
            yield put(
                actions.action.getListDataTaskDone(
                    request.data,
                    request.total,
                    isRefresh
                )
            )
        } else {
            yield put(actions.action.getListDataTaskDone([]))
        }
    } catch (ex) {
        console.log('load data chart : ', ex.message)
    }
}
function* saga_getListTaskUser(action) {
    try {
        const {
            uid,
            page_number,
            page_size,
            isRefresh,
        } = action.payload
        const request = yield call(
            getTodoTask,
            uid,
            page_number,
            page_size,
        )
        console.log('data todo', request)
        if (request.error.code === 200) {
            yield put(
                actions.action.getListDataTaskDone(
                    request.data,
                    request.total,
                    isRefresh
                )
            )
        } else {
            yield put(actions.action.getListDataTaskDone([]))
        }
    } catch (ex) {
        console.log('load data chart : ', ex.message)
    }
}
function* listen() {
    yield takeEvery(
        actions.type.GET_LIST_DATA_TASK_ADMIN,
        saga_getListTaskAdmin
    )
    yield takeEvery(actions.type.GET_LIST_DATA_TASK_USER, saga_getListTaskUser)
    yield takeEvery(
        actions.type.LOAD_DATA_TASK_USER_AND_SYSTEM,
        saga_loadDataChartUserSystem
    )
    yield takeEvery(
        actions.type.LOAD_DATA_CHART_EVENT_OBJECT,
        saga_ChartEventObject
    )
    yield takeEvery(
        actions.type.LOAD_DATA_CHART_OBJECT_EVENT,
        saga_ChartObjectEvent
    )
    yield takeEvery(
        actions.type.LOAD_DATA_COLECTED_BY_TIER,
        saga_getDataCollectedByTier
    )

    yield takeEvery(actions.type.LOAD_DATA_CHART_USER_TASK, saga_chartUserTask)
    yield takeEvery(actions.type.LOAD_DATA_CHART_ORG_TASK, saga_chartOrgTask)
    yield takeEvery(
        actions.type.LOAD_DATA_CHART_USER_COLLECTED,
        saga_chartUserCollected
    )
    yield takeEvery(
        actions.type.LOAD_DATA_TASK_SYSTEM_CHART,
        saga_loadDataChartTaskSystem
    )
    yield takeEvery(
        actions.type.GET_LIST_DATA_EVENT_DASHBOARD,
        saga_getListEventDashboard
    )
}

export default function* chartSaga() {
    yield all([fork(listen)])
}
